import React from 'react';
import {View, TableColumn, Table, LinkAction} from 'react-template';
import {withRouter} from 'react-router'
import { buscarFormulario } from '../../actions/FormActions';
import {buscarModelosCertificadoPorForm, deletarModeloCertificado}  from '../../actions/FormBuilderActions'

class FormCertifielData extends View {

    constructor(props){
        super(props);
        this.state = { 
            idFormulario: this.props.params.id,
            data: null,
            url: '/certificados/modelos',
            camposFiltrando: '',
            activeLoader: true,
        };
        this.camposComCertificado = []
    }

    loadForm(formID){
        buscarFormulario(formID, res => {
            const formulario = res.data;
            this.camposComCertificado = this.getListaDeCamposComCertificado(formulario.formEditavel);
            this.getForms(this.state.url + '?size=10');
        }, 
        error => {
            this.notifyError('Erro ao carregar Formulário!', '')
        })
    }

    getListaDeCamposComCertificado(formEditavel){
        const formEditavelJson = JSON.parse(formEditavel);
        const itens = formEditavelJson.itens;
        let camposComCertificado = [];
        if(formEditavelJson.temCertificado){
            camposComCertificado.push({key: 0, value: 0, text: formEditavelJson.titulo+' - Certificado do Evento'})
        }
        itens.forEach(item => {
            if(item.certificado){
                camposComCertificado.push({key: item.id, value:item.id, text: item.pergunta})
            }
        });
        return camposComCertificado;
    }

    formatData(resData){
        let content = [];
        resData.content.forEach(item => {
            let id = item.id;
            let tituloModelo = item.tituloModelo;
            let campo = this.camposComCertificado.filter( campo => campo.key === item.idCampo)[0].text

            content.push({id, tituloModelo, campo});
        });
        resData.content = content;
        return resData;
    }

    componentDidMount() {
        this.loadForm(this.props.params.id)
    }

    onPaginator = (url) => {
        this.getForms(url + this.state.camposFiltrando)
    }

    getForms = (url, filtrando = false) => {
        const idForm = this.state.idFormulario
        buscarModelosCertificadoPorForm(url, idForm, res => {
            if(filtrando && res.data.numberOfElements === 0){
                this.setState({camposFiltrando: ''})
                this.noResultOnFilter();
                return;
            }
            const resData = this.formatData(res.data);
            this.setState({ data: resData,
                activeLoader: false});
        }, error => {
            this.setState({activeLoader: false});
            this.notifyError("Erro ao carregar modelos", "");
        });
    }

    deleteModelo(e, data){
        e.preventDefault();
        this.setState({deleteId: data.id})
        this.displayModal(  'Deletar modelo',
            'Deletar modelo - '+data.tituloModelo,
            'Deseja realmente deletar o modelo: '+data.tituloModelo+', do campo: '+data.campo+'?',
            this.deletar.bind(this),
            this.fechar.bind(this));
    }

    deletar(){
        deletarModeloCertificado(this.state.deleteId, res => {
            this.retirarDadoLinha(this.state.deleteId)
            this.fechar()
            this.notifySucess('Modelo deletado com sucesso', '')
        }, error => {
            this.notifyError('Erro ao deletar o modelo', '')
        })
    }

    fechar(){
        this.setState({deleteId: null})
    }

    retirarDadoLinha(id){
        let newContent = this.state.data.content.filter( row => row.id !== id)
        let newData = this.state.data
        newData.content = newContent
        this.setState({data: newData})
    }

    dataMapper = (data) => {
        const path = this.props.location.pathname;
        return (
            <tr key={data.id}>
                <TableColumn width="50" headers="titulo" content={data.tituloModelo} label="Titulo" />
                <TableColumn width="40" headers="campo" content={data.campo} label="Campo do formulário"/>
                <TableColumn width="10" headers="acoes" action>
                    <LinkAction icone="edit" type="table" to={path+"/modelo?id="+data.id+"&acao=atualizar"} tooltip="Detalhar"/>
                    <LinkAction icone="delete" type="table" onClick={(e) => this.deleteModelo(e, data)} tooltip="Detalhar"/>
                </TableColumn>
            </tr>
        );
    }

    getTools(){

        return(
            <LinkAction icone="add" type="icon" to={this.props.location.pathname+"/modelo"} tooltip="Novo Modelo de certificado" color="light-grey"/>
        )
    }

    render() {
        return (
            <Table  title="Modelos de Certificado"
                summary="Listagem dos modelos de certificado para o formulário"
                url={this.state.url}
                data={this.state.data}
                dataMapper={this.dataMapper}
                onPaginator={this.onPaginator}
                tools={this.getTools()}
                displayLoading={this.state.activeLoader}
                card noPadding/>
        );
    }
}
export default withRouter(FormCertifielData)


// WEBPACK FOOTER //
// ./src/view/formulario/list/tabs/FormCertifielData.js